import appHolidays from "../../views/appSettings/holidays.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "holidays";
  const params = ["page", "limit"];

  $stateProvider.state("holidays", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appHolidays,
      },
    },
    reloadOnSearch: false,
    data: { title: "Holidays" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/holidays/holidays.urls.js